import React, { useEffect, useState } from "react";
import "./header.css";
import { TextField, Button } from "@mui/material";
import useUserStore from "../../Stores/userStore";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import LoginForm from "../LoginForm/login-form";
import CarritoComponent from "../Carrito/carrito";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import useCotizadorStore from "../../Stores/cotizadorStore";
import CotizadorComponent from "../Cotizador/cotizador";




function HeaderComponent() {
  const [showDialog, setShowDialog] = useState(false);
  const [showShoppingKart, setShowShoppingKart] = useState(false);
  const [showCotizador, setShowCotizador] = useState(false);

  const userName = useUserStore((state) => state.user);
  const shoppingKart = useShoppingKartStore((state) => state.shoppingKart);
  const cotizador = useCotizadorStore((state) => state.cotizador);
  const [ShowMenu, setShowMenu] = useState(false);

  const navlinks = document.getElementById("nav-response");
  let display = 0;

  const [quantity, setQuantity] = useState();
  const [cotQuantity, setCotQuantity] = useState()


 var currentValueKart = 0;
var SKQuantity=()=>{  
  if(shoppingKart.length === 0){
    setQuantity(0);
  }
  const currentQuantity = [];
  shoppingKart.map((el) =>{ 
    currentQuantity.push(el.qty);
    const initialValue = 0;
    const currentValueKart = currentQuantity.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue)  
   setQuantity(currentValueKart)

  })}


  useEffect(()=>{SKQuantity()}, [shoppingKart])




  var cotizadorCantidad = 0;
  var cotizaQuantity = () => {
    if(cotizador.length === 0){
      setCotQuantity(0);
    }
    const currentCotizadorQuantity = [];
    cotizador.map((el) =>{ 
    currentCotizadorQuantity.push(el.qty);
    const initvalue=0;
    const cotizadorCantidad = currentCotizadorQuantity.reduce((accumulator, currentValue) => accumulator + currentValue, initvalue)
    setCotQuantity(cotizadorCantidad)
  
  })}
 
  useEffect(()=> {cotizaQuantity()}, [cotizador])

  return (
    
    <header>
      <div className="inner-header ">
        <nav>
          {/* <a className="logo" href="#TOP" > */}
          <a className="logo" href="/#TOP">
            <img
              src="./Images/logoSerdanCompleto.png"
              alt="GS-Logo"
              className="img-logo"
            />
          </a>
          {/* </a> */}
          {/* {ShowMenu &&( */}
          <ul className="nav-links" id="nav-response">
            <a href="/#nosotros">
              <li className="underline-hover">QUIÉNES SOMOS</li>
            </a>
            <a href="/#comercializadora">
              <li className="underline-hover">COMERCIALIZADORA CASAR</li>
            </a>
            <a href="/#solarserdan">
              <li className="underline-hover">SOLAR SERDÁN</li>
            </a>
            <a href="/#refrigeracion">
              <li className="underline-hover">REFRIGERACIÓN SERDÁN</li>
            </a>
            <a href="/#aceroserdan">
              <li className="underline-hover">SERDÁN INOXIDABLES</li>
            </a>
            <a href="/#contacto">
              <li className="underline-hover border-right">CONTACTO</li>
            </a>

                        </ul>
             {/* )} */}
             <div class="inner-header2">
              <div className="relative">
                <li
                  className="underline-hover leftside cursor-pointer"
                  onClick={() => {
                    setShowDialog(!showDialog);
                  }}
                >
                  Inicio de Sesión/Registro
                </li>
                <div
                  style={{ display: showDialog ? "block" : "none", zIndex: '100' }}
                  className="login-dialog absolute right-0 -bot-30"
                  onMouseLeave={() => setShowDialog(false)}
                >
                  {userName ? (
                    <div>
                      <p>Bienvenido {userName}</p>
                    </div>
                  ) : (
                    <LoginForm />
                  )}
                </div>
              </div>
              <div className="relative">
                {/* <li className="FaCartShoppingBox"></li> */}
                <li
                  className="underline-hover leftside cursor-pointer"
                  onClick={() => {
                    setShowShoppingKart(!showShoppingKart);
                  }}
                >


       
              <p>
              <FontAwesomeIcon className="FaCartShoppingBox" icon={faCartShopping} />
              {quantity >= 1 ? <b>({quantity}) CARRITO</b> :  "CARRITO" }
                  

              </p>
    

           

                </li>

                

                <div
                  style={{ display: showShoppingKart ? "block" : "none", zIndex: '100' }}
                  className="carrito-dialog absolute right-0 -bot-30"
                  onMouseLeave={() => setShowShoppingKart(false)}
                >
                  {shoppingKart.length ? (
                    <div><CarritoComponent shoppingKart={shoppingKart} /></div>
                  ) : (
                    <div>No hay ningún elemento en el carrito</div>
                  )}

                </div>
              </div>
              <div className="relative">
                {/* <li className="FaCartShoppingBox"></li> */}
                <li
                  className="underline-hover leftside cursor-pointer"
                  onClick={() => {
                    setShowCotizador(!showCotizador);
                  }}
                >
                  {cotQuantity >= 1 ? <b>({cotQuantity}) COTIZADOR </b>: "COTIZADOR"}

                </li>


                <div
                  style={{ display: showCotizador ? "block" : "none", zIndex: '100' }}
                  className="carrito-dialog absolute right-0 -bot-30"
                  onMouseLeave={() => setShowCotizador(false)}
                >
                  {cotizador.length ? (
                    <div><CotizadorComponent cotizador={cotizador} /></div>
                  ) : (
                    <div>No hay ningún elemento en el cotizador</div>
                  )}

                </div>
              </div>
              </div>
          <button
            onClick={() => {
              setShowMenu(!ShowMenu);
            }}
            className="listIcon"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              className="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </button>
        </nav>
      </div>
      <font-awesome-icon icon="fa-solid fa-cart-shopping" />
    </header>
  );
}

export default HeaderComponent;
